import React from "react";
import { Close, SvgIconComponent } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";

interface FlyoutHeaderProps {
  icon: SvgIconComponent;
  title: string;
  onClose(): void;
}

/** Title bar of a base data map flyout. */
const FlyoutHeader: React.FC<FlyoutHeaderProps> = ({ icon: Icon, title, onClose }) => (
  <Box display="flex" alignItems="center" gap={1.5} pl={1.75} pr={1} py={1} borderBottom={1} borderColor="divider" flexShrink={0}>
    <Icon color="primary" />
    <Typography variant="h6" fontWeight={700} flexGrow={1}>
      {title}
    </Typography>
    <IconButton aria-label="Close" onClick={onClose}>
      <Close />
    </IconButton>
  </Box>
);

export default FlyoutHeader;
